// Kept out of the JSX so these rules can be driven directly against
// `reasoning/spec.py`'s own `validate()`.

// The six tiers `reasoning/effort.py` accepts, in the order it requires.
export const EFFORT_TIERS = ['minimal', 'low', 'medium', 'high', 'xhigh', 'max'];

// One row per `spec.py` Mode; `fields` is what the shape permits, and every field
// it omits is a rule `validate()` can no longer be asked about.
export const SHAPES = [
  { mode: 'none', label: "doesn't reason",
    hint: 'No thinking, at any setting.', fields: [] },
  { mode: 'toggle', label: 'on / off',
    hint: 'Thinking can be asked for, but not at a chosen depth.',
    fields: ['can_disable'] },
  { mode: 'effort', label: 'named levels',
    hint: 'A ladder of depths the caller picks from.',
    fields: ['effort', 'default', 'can_disable'] },
  { mode: 'budget', label: 'token budget',
    hint: 'The caller names a number of thinking tokens.',
    fields: ['budget', 'can_disable'] },
];

/** The spec a shape implies, with anything that shape cannot express dropped:
 *  `validate()` rejects `effort` tiers left behind by a switch to `toggle`. */
export function forShape(mode, prev = {}) {
  const shape = SHAPES.find((s) => s.mode === mode) || SHAPES[0];
  const next = { mode };
  if (shape.fields.includes('effort') && prev.effort?.length) next.effort = prev.effort;
  if (shape.fields.includes('default') && next.effort?.includes(prev.default)) {
    next.default = prev.default;
  }
  if (shape.fields.includes('budget')) next.budget = prev.budget || { min: 1024 };
  if (shape.fields.includes('can_disable') && prev.can_disable != null) {
    next.can_disable = prev.can_disable;
  }
  if (prev.betas?.length) next.betas = prev.betas;
  return next;
}

/** Add or remove one tier, rebuilt from the canonical order rather than appended,
 *  so "weakest to strongest" and "unique" hold however the chips are clicked. */
export function toggleTier(spec, tier) {
  const tiers = spec.effort || [];
  const effort = EFFORT_TIERS.filter(
    (t) => (t === tier ? !tiers.includes(t) : tiers.includes(t)));
  return { ...spec, effort,
           default: effort.includes(spec.default) ? spec.default : undefined };
}
